import clsx from "clsx";
import React from "react";
import { FunctionComponent } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { RadioProps } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import FontIcon from "../../../components/FontIcon";
import { FontIconNames } from "../../../components/FontIcon/FontIcon";

interface UserTypeRadioProps extends RadioProps {
  iconName: FontIconNames;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    width: 100,
    height: 100,
    zIndex: 9999999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "all .2s ease-in-out",
    fontSize: ".8em",
    [theme.breakpoints.down("sm")]: {
      borderRadius: 40,
      width: 80,
      height: 160,
    },

    "&:hover": {
      transform: "scale(1.2)",
      backgroundImage: "linear-gradient(225deg,#e6c224,#9c873d)",
      color: theme.palette.secondary.contrastText,
      [theme.breakpoints.down("sm")]: {
        transform: "scale(1.1)",
      },
    },
  },

  hoverIcon: {
    "&:hover": {
      transform: "scale(1.2)",
      backgroundImage: "linear-gradient(225deg,#e6c224,#9c873d)",
      color: theme.palette.secondary.contrastText,
      [theme.breakpoints.down("sm")]: {
        transform: "scale(1.1)",
      },
    },
  },
}));

const UserTypeRadio: FunctionComponent<UserTypeRadioProps> = ({
  iconName,
  ...props
}) => {
  const classes = useStyles();
  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={
        <FontIcon
          name={iconName}
          className={clsx(classes.icon, classes.hoverIcon)}
        />
      }
      icon={
        <FontIcon
          name={iconName}
          className={clsx(classes.icon, classes.hoverIcon)}
        />
      }
      {...props}
    />
  );
};

export default UserTypeRadio;
